import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/react-native/next/app/(main)/_/components/GlobalWebBackgroundManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StylesProvider"] */ "/home/runner/work/monorepo/monorepo/react-native/next/app/(main)/_/components/styles-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/react-native/next/app/(main)/_/helpers/framer-motion/LazyMotion.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/react-native/next/app/(main)/main.css");
;
import(/* webpackMode: "eager", webpackExports: ["SentryLazyInitComponent"] */ "/home/runner/work/monorepo/monorepo/react-native/src/api/sentry/sentryLazyInit.web.ts");
